import React from 'react';
import s from './contactInfo.module.css';
import instagramIcon from './images/instagram.svg';
import locationIcon from './images/location.svg';
import mailIcon from './images/mail.svg';
import phoneIcon from './images/phone.svg';
export default function ContactInfo() {
  return (
    <div className={s.holder}>
      <h4 className={s.title}>Адреса:</h4>
      <a className={s.link} href="https://goo.gl/maps/XkfSduqGTPeKNAeX7">
        <img className={s.image} src={locationIcon} alt={'location icon'} />
        вулиця Богдана Хмельницького, 52Б, місто Київ
      </a>

      <h4 className={s.title}>Телефон:</h4>
      <a className={s.link} href="tel:(050) 77-46-246">
        <img className={s.image} src={mailIcon} alt={'mail icon'} />
        (050) 77-46-246
      </a>

      <h4 className={s.title}>E-mail:</h4>
      <a className={s.link} href="mailto:info@gpro.com.ua">
        <img className={s.image} src={phoneIcon} alt={'phone icon'} />
        info@gpro.com.ua
      </a>

      <h4 className={s.title}>Instagram:</h4>
      <a className={s.link} href="https://www.instagram.com/gamepro.ua">
        <img className={s.image} src={instagramIcon} alt={'instagram icon'} />
        https://www.instagram.com/gamepro.ua
      </a>
    </div>
  );
}
